/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1059
 */

module.exports = {
  sliderWrapper: "SliderFiledNumber_sliderWrapper__74SNi",
  leftSliderText: "SliderFiledNumber_leftSliderText__1mz6_",
  rightSliderText: "SliderFiledNumber_rightSliderText__3zgjU"
}
